import { Sliders, UserPlus, Info, DollarSign,
  //  BarChart2,
   Grid,
   FileText,
} from 'react-feather';

const pagesSection = [
  {
    href: '/client/dashboard',
    title: 'Dashboard',
    icon: Sliders,
  },
  {
    href: 'produkter',
    title: 'Produkter',
    icon: Grid,
    children: [
      {
        href: '/client/pages',
        title: 'Landningssidor',
      },
      {
        href: '/client/hemsidor',
        title: 'Hemsidor',
      },
    ],
  },
  {
    href: 'leads',
    title: 'Kundförfrågningar',
    icon: UserPlus,
  },
  // Temporarily hidden until backend team completes their update
  // {
  //   href: 'statistik',
  //   title: 'Statistik',
  //   icon: BarChart2,
  //   children: [
  //     {
  //       href: '/client/statistik/hemsida',
  //       title: 'Hemsida',
  //     },
  //   ],
  // },
  {
    href: 'invoices',
    title: 'Fakturor',
    icon: DollarSign,
  },
  {
    href: '/client/avtal',
    title: 'Avtal',
    icon: FileText,
  },
  {
    href: 'info',
    title: 'Info',
    icon: Info,
    children: [
      {
        href: 'info/upload',
        title: 'Upload images',
      },
      {
        href: 'info/form',
        title: 'Form',
      },
    ],
  },
];

const navItems = [
  {
    title: '',
    pages: pagesSection,
  },
];

export default navItems;
